import { useRequestMedicalContext } from "../../Contexts/RequestMedicalTestContext";
import { CancelRounded, CheckCircleOutlineOutlined } from "@mui/icons-material";
import success from "../../assets/success.png";
import Button from "../../Components/Button";
import dayjs from "dayjs";

function ReqMedicalSuccess() {
  const {
    setSelectedProcedureClass,
    setSelectedProcedures,
    setDiagnosticOrders,
    setMappedProcedures,
    setSelectedPolicy,
    setSelectedOrders,
    setProcedureClass,
    setSelectedClinic,
    setFiles,
    navigate,
    setMonth,
    setYear,
    setUrl,
    summary,
  } = useRequestMedicalContext();

  return (
    <div className="flex flex-col items-center min-h-screen max-w-screen sm:bg-[#E7EEFA] ">
      <div className="bg-white w-screen mb-[56px] sm:my-24 sm:w-148 h-auto rounded-xl">
        <div className="sm:h-full flex flex-col my-3 ">
          <div className="mt-52 sm:mt-0 flex flex-col items-center justify-center text-center px-6">
            <img src={success} alt="Personal" className="h-24 w-24 my-4" />
            <p className="text-xl font-bold mb-3">Booking successful!</p>
            <p>
              {summary.map((data) => {
                return (
                  <div key={data.procedure}>
                    {`• ${data.procedure} - ${data.message.message} `}
                    {data.message.message === "Appointment created!" ? (
                      <CheckCircleOutlineOutlined fontSize="small" />
                    ) : (
                      <CancelRounded fontSize="small" />
                    )}
                  </div>
                );
              })}
            </p>
          </div>

          <div className="flex sm:flex-row flex-col items-center mt-6 sm:w-full justify-center absolute p-4 inset-x-0 bottom-0 sm:relative sm:px-8">
            <Button
              className="w-full h-14 text-white sm:mr-3"
              onClick={() => {
                setMonth(dayjs().format("MM"));
                setYear(dayjs().year());
                setSelectedProcedureClass([]);
                setSelectedProcedures([]);
                setDiagnosticOrders([]);
                setSelectedOrders([]);
                setMappedProcedures();
                setSelectedPolicy(null);
                setProcedureClass();
                setSelectedClinic();
                setFiles([]);
                setUrl();
                navigate("/home");
              }}
            >
              Back to dashboard
            </Button>
            <Button
              className="w-full h-14 text-white sm:mr-3"
              onClick={() => {
                navigate("/home");
              }}
            >
              Go back and configure
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ReqMedicalSuccess;
